const KEY = 'nm.pending';

export interface PendingAuth {
  email: string;
  intent: 'signup' | 'login' | 'reset';
  /** What the /verify step should do: create the account, reset the password, or
   * just log in with the code. */
  purpose: 'signup' | 'reset' | 'login';
  /** Chosen password, held only between /signup and /verify (signup flow). */
  password?: string;
  resendAfter: number;
  devCode?: string;
}

export function setPending(p: PendingAuth): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    /* ignore */
  }
}

export function getPending(): PendingAuth | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as PendingAuth) : null;
  } catch {
    return null;
  }
}

export function clearPending(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
